const getOrderFavoritesDropDown = state => state.orderFavoritesDropdown
export const getOrderFavorites = state => getOrderFavoritesDropDown(state).orderFavorites?.lists
export const getRecListId = state => getOrderFavoritesDropDown(state).orderFavorites?.lists?.find(l=>l.displaySequenceNumber===1)?.listId
